 <main class="point__main">
  @if (point().title) {
    <h2 class="point__title ci-paragraph-p1-semibold">
      {{ point().title | translate }}
    </h2>
  }
  
  @if (point().duration) {
    <div class="point__info">
      <ci-icon
        class="info__icon"
        name="duracion"
        type="svg"
      ></ci-icon>
      
      <span class="info__text ci-footer-semibold">
        {{ point().duration | duration }}
      </span>
    </div>
  }
</main>